import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    
    <footer className="footer ">
      
        <div style={{ height: "5px", backgroundColor: "#0084d9" }} />
        <div style={{ height: "8px", backgroundColor: "#046525" }} />
      <div className="container">
      <div className="container pt-5 pb-4">
        {/* ONE ROW, 5 COLUMNS */}
        <div className="row footer-cols">
          {/* Col 1 - LogE */}
          <div className="col-lg-3 col-md-6 mb-4 footer-col footer-col-loge">
            <div className="footer-about">
              <Link
                to="/"
                onClick={scrollToTop}
                className="logo d-flex align-items-center text-decoration-none mb-3"
              >
                <img
                  src="/assets/img/logocopyright.png"
                  alt="Log e Infotech"
                  style={{ maxHeight: "50px", marginRight: "10px" }}
                />
              </Link>
              <h6 className="fw-bold mb-3">Log e Infotech Pvt. Ltd.</h6>
              <div className="footer-contact-info text-dark small mb-4">
                <p>Shop no. 18, Srno- 81/1, bandal capital,</p>
                <p>Near Kothrud depo, paud road, Kothrud,</p>
                <p>India - MH - Pune - 411038</p>
              </div>

              <div className="small mb-4">
                <p className="mb-1">
                  <strong>Phone:</strong> +91 7773967002
                </p>
                <p className="mb-0">
                  <strong>Email:</strong>{" "}
                  <a
                    href="mailto:info@logesolutions.net"
                    className="text-decoration-none contact-email"
                  >
                    info@logesolutions.net
                  </a>
                </p>
              </div>

              <div className="social-links d-flex gap-2">
                <a href="#" className="social-icon" aria-label="Twitter">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="#" className="social-icon" aria-label="Facebook">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="#" className="social-icon" aria-label="Instagram">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="#" className="social-icon" aria-label="LinkedIn">
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Col 2 - Company Links */}
          <div className="col-lg-3 col-md-6 col-sm-6 mb-4 footer-col footer-col-company">
            <h5 className="footer-heading">Company Links</h5>
            <ul className="list-unstyled d-flex flex-column gap-2 small">
              <li>
                <Link
                  to="/about-us"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/contact-us"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/careers"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  Careers
                </Link>
              </li>
              <li>
                <Link
                  to="/partner-with-us"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  Partner With Us
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-conditions"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/refund-cancellation-policy"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  Refund & Cancellation Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/brochure"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  Brochure
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3 - HealthCare */}
          <div className="col-lg-3 col-md-6 col-sm-6 mb-4 footer-col footer-col-health">
            <h5 className="footer-heading">HealthCare Software</h5>
            <ul className="list-unstyled d-flex flex-column gap-2 small">
              <li>
                <Link
                  to="/medisevas-hospital-erp"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  Medisevas Hospital ERP
                </Link>
              </li>
              <li>
                <Link
                  to="/medisevas-appointment-portal"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  Medisevas Appointment Portal
                </Link>
              </li>
              <li>
                <Link
                  to="/queue-management"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  Queue Management
                </Link>
              </li>
              <li>
                <Link
                  to="/teleHealthCare-management"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  TeleHealthCare Management
                </Link>
              </li>
              <li>
                <Link
                  to="/hospital-analytics-management"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  HealthCare Analytics
                </Link>
              </li>
              <li>
                <Link
                  to="/medisevas-healthCare-imaging"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  Medisevas HealthCare Imaging
                </Link>
              </li>
              <li>
                <Link
                  to="/materia-medica-repertory"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  Materia Medica Repertory
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 4 - Laboratory */}
          <div className="col-lg-3 col-md-6 col-sm-6 mb-4 footer-col footer-col-lab">
            <h5 className="footer-heading">Laboratory Software</h5>
            <ul className="list-unstyled d-flex flex-column gap-2 small">
              <li>
                <Link
                  to="/pathology-lab-management"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  Pathology Lab Management
                </Link>
              </li>
              <li>
                <Link
                  to="/radiology-lab-management"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  Radiology Lab Management
                </Link>
              </li>
              <li>
                <Link
                  to="/dental-lab-management"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  Dental Lab Management
                </Link>
              </li>
              <li>
                <Link
                  to="/embryology-lab-management"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  Embryology Lab Management
                </Link>
              </li>
              <li>
                <Link
                  to="/egg-sperm-bank-management"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  Egg & Sperm Bank Management
                </Link>
              </li>
              <li>
                <Link
                  to="/blood-bank-management"
                  onClick={scrollToTop}
                  className="footer-link"
                >
                  Blood Bank Management
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 5 - For Clinic */}
          <div className="col-lg-3 col-md-6 col-sm-6 mb-4 footer-col footer-col-clinic">
            <h5 className="footer-heading">For Clinic</h5>
            <ul className="list-unstyled d-flex flex-column gap-2 small">
              <li>
                <Link
                  to="/ayurvedic-clinic-management"
                  onClick={scrollToTop}
                  className="footer-link text-nowrap"
                >
                  Ayurvedic Clinic Management
                </Link>
              </li>
              <li>
                <Link
                  to="/dental-clinic-management"
                  onClick={scrollToTop}
                  className="footer-link text-nowrap"
                >
                  Dental Clinic Management
                </Link>
              </li>
              <li>
                <Link
                  to="/gynecology-clinic-management"
                  onClick={scrollToTop}
                  className="footer-link text-nowrap"
                >
                  Gynecology Clinic Management
                </Link>
              </li>
              <li>
                <Link
                  to="/pediatrics-clinic-management"
                  onClick={scrollToTop}
                  className="footer-link text-nowrap"
                >
                  Pediatrics Clinic Management
                </Link>
              </li>
              <li>
                <Link
                  to="/ophthalmology-clinic-management"
                  onClick={scrollToTop}
                  className="footer-link text-nowrap"
                >
                  Ophthalmology Clinic Management
                </Link>
              </li>
              <li>
                <Link
                  to="/homeopathy-clinic-management"
                  onClick={scrollToTop}
                  className="footer-link text-nowrap"
                >
                  Homeopathy Clinic Management
                </Link>
              </li>
              <li>
                <Link
                  to="/ivf-clinic-management"
                  onClick={scrollToTop}
                  className="footer-link text-nowrap"
                >
                  IVF Clinic Management
                </Link>
              </li>
              <li>
                <Link
                  to="/medicine-clinic-management"
                  onClick={scrollToTop}
                  className="footer-link text-nowrap"
                >
                  Medicine Clinic Management
                </Link>
              </li>
              <li>
                <Link
                  to="/orthopedic-clinic-management"
                  onClick={scrollToTop}
                  className="footer-link text-nowrap"
                >
                  Orthopedic Clinic Management
                </Link>
              </li>
              <li>
                <Link
                  to="/physiotherapy-clinic-management"
                  onClick={scrollToTop}
                  className="footer-link text-nowrap"
                >
                  Physiotherapy Clinic Management
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* <div className="copyright-bar py-3">
        <div className="container copyright text-center mt-4">
        <p>
          <span>Copyright 2025</span>{" "} ©
          <strong className="px-1 sitename">Log e Infotech Pvt. Ltd.</strong>{" "}
          <span>All Rights Reserved.</span>
        </p>
        </div>
  </div> */}
  
      <button
        className="scroll-top-button"
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <i className="fas fa-chevron-up"></i>
      </button>

      <style>
        {`
          .footer {
            background-color: #ffffff;
            color: #212529;
            font-family: "Roboto", sans-serif;
            font-size: 14px;
            border-top: 1px solid #f3f9ff;
          }

          .footer h4, .footer h5 {
            color: #2d465e;
            font-family: "Nunito", sans-serif;
          }

          .footer-heading {
            font-size: 16px;
            font-weight: bold;
            position: relative;
            padding-bottom: 12px;
            margin-bottom: 20px;
            text-align: left !important;
          }

          .footer-heading::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0;
            width: 40px;
            height: 2px;
            background-color: #046525;
          }

          .footer-link {
           font-size: 13px; 
            color: rgba(33, 37, 41, 0.7);
            text-decoration: none;
            transition: all 0.3s ease;
            white-space: nowrap;
            display: block;
          }

          .footer-link:hover {
            color: #046525;
            padding-left: 5px;
          }

          .footer-contact-info p {
            white-space: nowrap;
            margin-bottom: 0.25rem;
          }

          .contact-email {
            color: #046525;
            white-space: nowrap;
          }

          .social-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 36px;
            border-radius: 50%;
            border: 1px solid rgba(33, 37, 41, 0.2);
            color: rgba(33, 37, 41, 0.6);
            text-decoration: none;
            transition: 0.3s;
          }

          .social-icon:hover {
            background-color: #046525;
            color: #ffffff;
            border-color: #046525;
          }

          .copyright-bar {
            background-color: #f8f9fa;
            border-top: 1px solid #e9ecef;
          }

          .scroll-top-button {
            position: fixed;
            bottom: 20px;
            left: 20px;
            width: 45px;
            height: 45px;
            background-color: #046525;
            color: white;
            border: none;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 4px 10px rgba(0,0,0,0.2);
            cursor: pointer;
            z-index: 1000;
            transition: 0.3s;
          }

          .scroll-top-button:hover {
            background-color: #146c43;
            transform: translateY(-3px);
          }

          .footer,
          .footer * {
            text-align: left !important;
          }

          .footer ul li {
            white-space: nowrap;
          }

          /* Mobile: 1 column */
          @media (max-width: 575.98px) {
            .footer-cols > .footer-col,
            .footer-cols > .footer-col-loge,
            .footer-cols > .footer-col-clinic {
              flex: 0 0 100% !important;
              max-width: 100% !important;
            }
          }

          /* Tablet: 2 columns */
          @media (min-width: 576px) and (max-width: 991.98px) {
            .footer-cols > .footer-col,
            .footer-cols > .footer-col-loge,
            .footer-cols > .footer-col-clinic {
              flex: 0 0 50% !important;
              max-width: 50% !important;
            }
          }

           /* 992–1250px:
                Row1: LogE + Company + Health + Lab
                Row2: Clinic                       */
            @media (min-width: 992px) and (max-width: 1250px) {
              .footer-cols {
                display: flex;
                flex-wrap: wrap;
              }

              .footer-col-loge,
              .footer-col-company,
              .footer-col-health,
              .footer-col-lab {
                flex: 0 0 25% !important;      /* 4 columns in row 1 */
                max-width: 25% !important;
              }

              .footer-col-loge   { order: 1; }
              .footer-col-company{ order: 2; }
              .footer-col-health { order: 3; }
              .footer-col-lab    { order: 4; }

              /* Clinic starts new row but keeps same width */
              .footer-col-clinic {
                flex: 0 0 25% !important;      /* same width as others */
                max-width: 25% !important;
                order: 5;                      /* row 2, first col */
                margin-top: 1rem;
              }
            }
                      /* ≥1251px: 5 columns; LogE ~25%, others auto-shrink */
          @media (min-width: 1251px) {
            .footer-cols {
              display: flex;
              flex-wrap: nowrap;
            }

            .footer-col-loge {
              flex: 0 0 25% !important;
              max-width: 25% !important;
            }

            .footer-col-company,
            .footer-col-health,
            .footer-col-lab,
            .footer-col-clinic {
              flex: 0 0 18.75% !important; /* 75 / 4 */
              max-width: 18.75% !important;
            }
          }
        .copyright-bar, .copyright-bar * {
  text-align: center !important;
}

/* Baaki footer columns ko left align rakhne ke liye */
.footer-col, .footer-col * {
  text-align: left !important;
}

        `}
      </style>
  
    </div>
      <div className="copyright-bar py-4">
  <div className="container">
    <div className="row">
      <div className="col-12 text-center">
        <p className="mb-0 small">
          Copyright 2026 © <strong className="px-1">Log e Infotech Pvt. Ltd.</strong> All Rights Reserved.
        </p>
      </div>
    </div>
  </div>
</div>
    </footer>
    
  );
};

export default Footer;
